import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningRequestsService} from "../../services/planning-requests.service";
import {RecurringType} from "../../../commons/types/recurring.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class PlanningTemplateView implements IController {
  template: any;

  public selectedTab: any;
  public isRecurring: any;
  public days: any;
  public clusteringAreas: any[] = [];

  private locationTypes: any;
  private fulfillmentImportFilters: any;
  public dispatchScheduleSettingsTime: any;
  private loadedClusteringAreaIdsKey: string;

  /* @ngInject */
  constructor(private $state, private bringozLoaderService: BringozLoaderService, private planningRequestsService: PlanningRequestsService, private planningAlertsService: PlanningAlertsService, private planningConstants,
              private moment, private splitService, private commonsConstants, private commonsAlertsService: CommonsAlertsService,
              private planningClusteringAreasRequestsService, private $log, private $scope: IScope) {
    this.locationTypes = planningConstants.locationTypes;
  }

  $onInit() {
    this.selectedTab = 'Services';
    this.isRecurring = {
      enabled: !!this.template?.projectTemplateScheduleSettings
    };
    this.days = angular.copy(this.commonsConstants.daysCheckboxConfig);

    if (this.template.projectTemplateScheduleSettings?.eventSchedule?.byWeekDay?.length) {
      _.forOwn(this.days, (value, key) => {
        if (_.includes(this.template.projectTemplateScheduleSettings.eventSchedule.byWeekDay, key)) {
          value.enabled = true;
        }
      })
    }

    if (this.template.fulfillmentImport) {
      this.initFulfillmentImportFilters(this.template.fulfillmentFilter);
    }

    if (!!this.template.omsFilter) {
      this.template.omsFilter.filterByCreatedAt = this.template.omsImportByCreatedAt;
    }

    if (!this.template.settings) {
      this.template.settings = {};
    }

    if (!this.template.clusteringAreaIds) {
      this.template.clusteringAreaIds = [];
    }

    if (!this.template.settings.clusteringSettings) {
      this.template.settings.clusteringSettings = {};
    }

    if (!this.template.settings.prioritySettings) {
      this.template.settings.prioritySettings = {}
    }

    if (!_.get(this.template, 'settings.driverLocationSettings', false)) {
      this.template.settings.driverLocationSettings = {}
    }

    if (!_.get(this.template, 'settings.serviceLocationSettings', false)) {
      this.template.settings.serviceLocationSettings = {}
    }

    if (!_.get(this.template.settings, 'driverLocationSettings.departurePointType', false)) {
      this.template.settings.driverLocationSettings.departurePointType = this.locationTypes[0];
    }

    if (!_.get(this.template.settings, 'driverLocationSettings.destinationPointType', false)) {
      this.template.settings.driverLocationSettings.destinationPointType = this.locationTypes[0];
    }

    if (!_.get(this.template.settings, 'serviceLocationSettings.departurePointType', false)) {
      this.template.settings.serviceLocationSettings.departurePointType = 'UNDEFINED';
    }

    if (!_.get(this.template.settings, 'serviceLocationSettings.destinationPointType', false)) {
      this.template.settings.serviceLocationSettings.destinationPointType = 'UNDEFINED';
    }

    if (!!this.template.dispatchScheduleSettings?.time) {
      this.dispatchScheduleSettingsTime = this.moment(new Date(`01/01/1970 ${this.template.dispatchScheduleSettings.time}`))
    }

    if (this.template.importAllocationResourceFilter && !this.template.importAllocationResourceFilter.resourceTags) {
      this.template.importAllocationResourceFilter.resourceTags = [];
    }

    this._loadClusteringAreasForMap();
  };

  // ******************************
  //        Public methods
  // ******************************


  onSettingsChange(settings) {
    this.template.settings = settings;
  }

  onTemplateChange(template) {
    if (!template) {
      return;
    }

    this.template = _.assign(this.template, template);
    this._loadClusteringAreasForMap();
  }

  onClusteringAreasUpdated(clusteringAreas) {
    this.clusteringAreas = angular.copy(clusteringAreas || []);
  }

  onOmsImportSwitchChange(isEnabled) {
    if (!this.template.omsFilter && isEnabled) {
      this.template.omsFilter = {};
    }
  }

  onDispatchImportSwitchChange(isEnabled) {
    if (!this.template.dispatchFilter && isEnabled) {
      this.template.dispatchFilter = {};
    }

    if (!isEnabled) {
      this.template.abortServicesSettings.filter = undefined;
    }

  }

  onAddAbortedServicesSettings() {
    if (!this.template.abortServicesSettings.filter) {
      this.template.abortServicesSettings.filter = this.template.dispatchFilter;
    } else {
      this.template.abortServicesSettings.filter = undefined;
    }
  }

  onImportVehicleResourcesSwitchChange(isEnabled) {
    this.template.importVehicleResourceFilter = isEnabled ? {} : undefined;
  }

  onImportAllocationResourcesSwitchChange(isEnabled) {
    if (isEnabled && !this.template.importAllocationResourceFilter) {
      this.template.importAllocationResourceFilter = {
        resourceTags: []
      };
    } else if (!isEnabled) {
      this.template.importAllocationResourceFilter = undefined;
    }
  }

  onImportAgentScheduleResourcesSwitchChange(isEnabled) {
    this.template.importAgentScheduleResourceFilter = isEnabled ? {} : undefined;
  }

  onChangeVehicleResourcesTypes(types) {
    _.set(this.template, 'importVehicleResourceFilter.types', types);
  }

  onChangeVehicleResourcesLabels(labels) {
    _.set(this.template, 'importVehicleResourceFilter.labels', labels);
  }

  onChangeResourcesAllocationsBranches(branchIds) {
    _.set(this.template, 'importAllocationResourceFilter.branchIds', branchIds);
    _.unset(this.template, 'importAllocationResourceFilter.agentIds');
  }

  onChangeResourcesAllocationsSkills(skills) {
    _.set(this.template, 'importAllocationResourceFilter.skills', skills);
  }

  onChangeResourcesAllocationsVehicleTypes(vehicleTypes) {
    _.set(this.template, 'importAllocationResourceFilter.vehicleTypes', vehicleTypes);
  }

  onChangeResourcesAllocationsVehicleTypeIds(vehicleTypeIds) {
    _.set(this.template, 'importAllocationResourceFilter.vehicleTypeIds', vehicleTypeIds);
  }

  onChangeResourcesAllocationsResourceTags(resourceTags) {
    _.set(this.template, 'importAllocationResourceFilter.resourceTags', resourceTags);
  }

  onChangeResourcesAllocationsTags(agentTags, isExcludeMode) {
    if (isExcludeMode) {
      _.set(this.template, 'importAllocationResourceFilter.excludedAgentTags', agentTags);
      _.unset(this.template, 'importAllocationResourceFilter.agentTags');
    } else {
      _.set(this.template, 'importAllocationResourceFilter.agentTags', agentTags);
      _.unset(this.template, 'importAllocationResourceFilter.excludedAgentTags');
    }
    _.unset(this.template, 'importAllocationResourceFilter.agentIds');
  }

  onChangeResourcesAllocationsAgents(agentIds) {
    _.set(this.template, 'importAllocationResourceFilter.agentIds', agentIds);
  }

  onChangeResourcesAgentScheduleBranches(branchIds) {
    _.set(this.template, 'importAgentScheduleResourceFilter.branchIds', branchIds);
    _.unset(this.template, 'importAgentScheduleResourceFilter.agentIds');
  }

  onChangeResourcesAgentScheduleAgentTags(agentTags, isExcludeMode) {
    if (isExcludeMode) {
      _.set(this.template, 'importAgentScheduleResourceFilter.excludedAgentTags', agentTags);
      _.unset(this.template, 'importAgentScheduleResourceFilter.agentTags');
    } else {
      _.set(this.template, 'importAgentScheduleResourceFilter.agentTags', agentTags);
      _.unset(this.template, 'importAgentScheduleResourceFilter.excludedAgentTags');
    }

    _.unset(this.template, 'importAgentScheduleResourceFilter.agentIds');
  }

  onChangeResourcesAgentScheduleAgentAgentIds(agentIds) {
    _.set(this.template, 'importAgentScheduleResourceFilter.agentIds', agentIds);
  }

  onAddPriorityStep() {
    if (!this.template.settings.prioritySettings.slaPriority) {
      this.template.settings.prioritySettings.slaPriority = [];
    }

    const previousStep = _.get(this.template.settings.prioritySettings.slaPriority, this.template.settings.prioritySettings.slaPriority.length - 1, {});
    const step = {slaInHours: (previousStep.slaInHours ? previousStep.slaInHours + 1 : 24), priority: 5};

    this.template.settings.prioritySettings.slaPriority.push(step);
  }

  onChangePriorityStep(slaInHours, index) {
    const previousStep = _.get(this.template.settings.prioritySettings.slaPriority, index - 1);
    if (previousStep && previousStep.slaInHours >= slaInHours) {
      this.template.settings.prioritySettings.slaPriority[index].slaInHours = (previousStep.slaInHours + 1);
    }
  }

  onRemovePriorityStep(index) {
    this.template.settings.prioritySettings.slaPriority.splice(index, 1);
  }

  onUpdateTemplate(form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      if (!!this.template.projectTemplateScheduleSettings && this.template.projectTemplateScheduleSettings.eventSchedule?.freq !== RecurringType.WEEKLY) {
        if (!this.template.projectTemplateScheduleSettings.eventSchedule) {
          this.template.projectTemplateScheduleSettings.eventSchedule = {};
        }
        this.template.projectTemplateScheduleSettings.eventSchedule.byWeekDay = [];
      }

      this.bringozLoaderService.on();
      if (this.template.fulfillmentImport) {
        this.template.fulfillmentFilter = {
          stepFilter: {
            from: this.moment(this.fulfillmentImportFilters.from).valueOf(),
            to: this.moment(this.fulfillmentImportFilters.to).valueOf(),
            accountIds: this.fulfillmentImportFilters.accountIds,
            vehicleIds: this.fulfillmentImportFilters.vehicleIds,
            schedulingRequired: this.fulfillmentImportFilters.schedulingRequired,
            noFromLocation: this.fulfillmentImportFilters.noFromLocation,
            noToLocation: this.fulfillmentImportFilters.noToLocation,
            obligateTimeWindow: this.fulfillmentImportFilters.obligateTimeWindow,
            isReturn: this.fulfillmentImportFilters.isReturnDelivery,
            branchIds: this.fulfillmentImportFilters.branchIds,
            serviceAreaIds: this.fulfillmentImportFilters.serviceAreaIds,
            tags: this.fulfillmentImportFilters.tags,
            excludedTags: this.fulfillmentImportFilters.excludedTags,
            routed: this.fulfillmentImportFilters.inRoute,
            programTypes: this.fulfillmentImportFilters.programIds,
            approvalStatuses: this.fulfillmentImportFilters.approvalStatuses,
            types: this.fulfillmentImportFilters.serviceTypes,
            displayStatuses: this.fulfillmentImportFilters.displayStatuses,
            depotIds: this.fulfillmentImportFilters.depotIds,
            filterByCreatedAt: this.fulfillmentImportFilters.filterByCreatedAt,
            agentIds: this.fulfillmentImportFilters.agentIds,
            firstMile: this.fulfillmentImportFilters.fulfillmentMileType === 'firstMile' ? true : undefined,
            middleMile: this.fulfillmentImportFilters.fulfillmentMileType === 'middleMile' ? true : undefined,
            lastMile: this.fulfillmentImportFilters.fulfillmentMileType === 'lastMile' ? true : undefined
          },
          fulfillmentFilter: {
            packageTypes: this.fulfillmentImportFilters.packageIds?.length ? this.fulfillmentImportFilters.packageIds : undefined
          }
        }
      }
      this.planningRequestsService.updateTemplate(this.template)
        .then(() => {
          this.planningAlertsService.updateTemplateSuccess();
          this.$state.go(this.planningConstants.states.templates);
        })
        .catch(() => {
          this.planningAlertsService.updateTemplateError();
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  onTabSelection(tab) {
    this.selectedTab = tab !== tab.selectedTab ? tab : undefined;
  }

  // Orders Filters
  onChangeOmsFilter(filters) {
    this.template.omsFilter = filters;
    this.template.omsImportByCreatedAt = filters.filterByCreatedAt;
  }

  // Dispatch Filters
  onChangeDispatchFilter(filters) {
    this.template.dispatchFilter = filters
  }

  // Fulfillment Steps
  onChangeFulfillmentImportFilters(filters) {
    this.fulfillmentImportFilters = filters
  }

  onFulfillmentImportChange() {
    if (this.template.fulfillmentImport) {
      this.initFulfillmentImportFilters();
    }
  }

  private initFulfillmentImportFilters(filters?) {
    if (!!filters) {
      this.fulfillmentImportFilters = {
        from: this.moment(filters.stepFilter.from).toDate(),
        to: this.moment(filters.stepFilter.to).endOf('month').toDate(),
        branchIds: filters.stepFilter.branchIds,
        accountIds: filters.stepFilter.accountIds,
        serviceAreaIds: filters.stepFilter.serviceAreaIds,
        depotIds: filters.stepFilter.depotIds,
        serviceTypes: filters.stepFilter.types,
        agentIds: filters.stepFilter.agentIds,
        tags: filters.stepFilter.tags,
        vehicleIds: filters.stepFilter.vehicleIds,
        displayStatuses: filters.stepFilter.displayStatuses,
        approvalStatuses: filters.stepFilter.approvalStatuses,
        programIds: filters.stepFilter.programTypes,
        packageIds: filters.fulfillmentFilter.packageTypes,
        schedulingRequired: filters.stepFilter.schedulingRequired,
        obligateTimeWindow: filters.stepFilter.obligateTimeWindow,
        inRoute: filters.stepFilter.routed,
        noFromLocation: filters.stepFilter.noFromLocation,
        noToLocation: filters.stepFilter.noToLocation,
        fulfillmentMileType: undefined,
        isReturnDelivery: filters.stepFilter.isReturn,
        filterByCreatedAt: filters.stepFilter.filterByCreatedAt
      }
      if (filters.stepFilter.firstMile) {
        this.fulfillmentImportFilters.fulfillmentMileType = 'firstMile'
      }
      if (filters.stepFilter.middleMile) {
        this.fulfillmentImportFilters.fulfillmentMileType = 'middleMile'
      }
      if (filters.stepFilter.lastMile) {
        this.fulfillmentImportFilters.fulfillmentMileType = 'lastMile'
      }
    } else {
      this.fulfillmentImportFilters = {
        from: this.moment().startOf('month').toDate(),
        to: this.moment().endOf('month').toDate(),
        branchIds: [],
        accountIds: [],
        serviceAreaIds: [],
        depotIds: [],
        serviceTypes: [],
        agentIds: [],
        tags: [],
        vehicleIds: [],
        displayStatuses: [],
        approvalStatuses: [],
        programIds: [],
        packageIds: [],
        schedulingRequired: undefined,
        obligateTimeWindow: undefined,
        inRoute: undefined,
        noFromLocation: undefined,
        noToLocation: undefined,
        fulfillmentMileType: undefined,
        isReturnDelivery: undefined,
        filterByCreatedAt: this.splitService.getSiteFulfillmentSettings(this.splitService.getSiteId()).filterByCreatedAt
      }
    }
  }

  private _loadClusteringAreasForMap() {
    const ownerId = this.template?.id;
    const areaIds = this.template?.clusteringAreaIds || [];
    const idsKey = _.sortBy(areaIds).join(',');

    if (this.loadedClusteringAreaIdsKey === idsKey) {
      return;
    }

    this.loadedClusteringAreaIdsKey = idsKey;

    if (!ownerId || !areaIds.length) {
      this.clusteringAreas = [];
      return;
    }

    this.planningClusteringAreasRequestsService.getClusteringAreasForMap(ownerId, areaIds)
      .then((areas) => {
        const currentKey = _.sortBy(this.template?.clusteringAreaIds || []).join(',');
        if (currentKey !== idsKey) {
          return;
        }

        this.clusteringAreas = areas;
      })
      .catch((error) => {
        this.$log.error('Failed to load clustering areas for map', error);
        this.clusteringAreas = [];
      });
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningTemplateView', {
    bindings: {
      template: '<'
    },
    template: require('./planning-template-view.html').default,
    controller: PlanningTemplateView
  });
